import * as XLSX from 'xlsx';
import { ExcelSheetData } from '../types';

export const BRL_FMT = '"R$" #,##0.00;[Red]-"R$" #,##0.00';

export function sheetDataToWorksheet(data: ExcelSheetData): XLSX.WorkSheet {
  const ws = XLSX.utils.aoa_to_sheet(data.rows as (string | number)[][], {
    cellDates: false,
  });

  ws['!cols'] = data.colWidths.map((wch) => ({ wch }));

  const valueStart = data.valueColumnStart ?? 2;
  const range = XLSX.utils.decode_range(ws['!ref'] || 'A1');

  for (let R = 0; R <= range.e.r; R += 1) {
    const labelAddr = XLSX.utils.encode_cell({ r: R, c: 0 });
    const labelCell = ws[labelAddr];
    const isPercentRow =
      labelCell &&
      typeof labelCell.v === 'string' &&
      labelCell.v.startsWith('× Alíquota');

    for (let C = valueStart; C <= range.e.c; C += 1) {
      const addr = XLSX.utils.encode_cell({ r: R, c: C });
      const cell = ws[addr];
      if (cell && typeof cell.v === 'number') {
        cell.t = 'n';
        cell.z = isPercentRow && C === 2 ? '0.00%' : BRL_FMT;
      }
    }

    if (
      labelCell &&
      typeof labelCell.v === 'string' &&
      labelCell.v.includes('\n')
    ) {
      labelCell.s = {
        ...(labelCell.s || {}),
        alignment: { wrapText: true, vertical: 'top' },
      };
    }
  }

  return ws;
}

/** Planilha “Cálculo por pessoa” com blocos lado a lado. */
export function buildCalculoPorPessoaWorksheet(
  matrix: (string | number | null)[][],
  numPeople: number,
): XLSX.WorkSheet {
  const CALCULO_PESSOA_COLS = 3;
  const CALCULO_PESSOA_GAP = 1;
  const CALCULO_PESSOA_BLOCK = CALCULO_PESSOA_COLS + CALCULO_PESSOA_GAP;

  const ws = XLSX.utils.aoa_to_sheet(matrix as (string | number)[][], {
    cellDates: false,
  });

  const colWidths: Array<{ wch: number }> = [];
  for (let i = 0; i < numPeople; i += 1) {
    colWidths.push({ wch: 38 }, { wch: 44 }, { wch: 18 });
    if (i < numPeople - 1) colWidths.push({ wch: 2 });
  }
  ws['!cols'] = colWidths;

  const range = XLSX.utils.decode_range(ws['!ref'] || 'A1');
  for (let R = 0; R <= range.e.r; R += 1) {
    for (let i = 0; i < numPeople; i += 1) {
      const valueCol = 2 + i * CALCULO_PESSOA_BLOCK;
      if (valueCol > range.e.c) break;
      const addr = XLSX.utils.encode_cell({ r: R, c: valueCol });
      const cell = ws[addr];
      if (cell && typeof cell.v === 'number') {
        cell.t = 'n';
        cell.z = BRL_FMT;
      }
    }
  }
  return ws;
}
